import React from 'react';
import {
  Box,
  Container,
  SimpleGrid,
  VStack,
  Heading,
  Text,
  Icon,
  Link,
} from '@chakra-ui/react';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);

const ContactInfo = ({ data }) => {
  return (
    <Box py={{ base: 12, md: 20 }} bg="brand.50">
      <Container maxW="container.xl">
        <MotionBox
          textAlign="center"
          mb={12}
          initial={{ y: 20, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <Heading
            as="h2"
            fontSize={{ base: '2xl', md: '4xl' }}
            color="brand.700"
            mb={4}
          >
            {data.title}
          </Heading>
        </MotionBox>

        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={8}>
          {data.methods.map((method, index) => (
            <MotionBox
              key={index}
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
            >
              <Box
                bg="white"
                p={6}
                borderRadius="xl"
                boxShadow="md"
                textAlign="center"
                h="full"
                _hover={{ boxShadow: 'xl', transform: 'translateY(-4px)' }}
                transition="all 0.3s"
              >
                <VStack spacing={3}>
                  <Icon
                    as={method.icon}
                    boxSize={10}
                    color="accent.green"
                  />
                  <Text fontWeight="600" color="brand.700">
                    {method.title}
                  </Text>
                  {method.href ? (
                    <Link
                      href={method.href}
                      color="brand.500"
                      fontSize="sm"
                      onClick={() => {
                        if (method.event) {
                          // GA Event tracking
                          console.log(`GA Event: ${method.event}`);
                        }
                      }}
                    >
                      {method.value}
                    </Link>
                  ) : (
                    <Text color="brand.500" fontSize="sm">
                      {method.value}
                    </Text>
                  )}
                </VStack>
              </Box>
            </MotionBox>
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  );
};

export default ContactInfo;
